import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const restUrl = authorizationServicesPath + '/admin/organization/organization'

export default class AllOrganizationService {

    static async getAll() {
        return axios.get(restUrl + "/get-all");
    }

    static async update(id, status) {
        return await axios.patch(restUrl + "/" + id + "/set-unable?status=" + status,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async updateMaxUserAmount(id, amount) {
        return await axios.patch(restUrl + "/" + id + "/set-max-user-amount?maxUserAmount=" + amount,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}